import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import shallowCompare from 'react-addons-shallow-compare'
import { select } from 'd3-selection'

class AxisRenderer extends Component {
  constructor(props) {
    super(props)
    this.renderAxis = this.renderAxis.bind(this)
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState)
  }

  componentDidUpdate() {
    // console.debug('calling from update....');
    this.renderAxis()
  }

  componentDidMount() {
    // console.debug('calling from mount....');
    this.renderAxis()
  }

  renderAxis() {
    // console.debug('rendering axis....');
    const node = ReactDOM.findDOMNode(this)
    select(node).call(this.props.axis)
  }

  render() {
    const { dx = 0, dy = 0 } = this.props
    const translate = `translate(${dx},${dy})`
    return <g className={this.props.className} transform={translate} />
  }
}
export default AxisRenderer
